import api from "@/lib/api";
import type { Me } from "@/types/me/api-types/me-types";

export const meApi = {
  getMe: async (): Promise<Me> => {
    const response = await api.get<Me>("/me");
    return response.data;
  },
};
